const reconcileBillDetailState = {
  isShowDeductMoney: false,
  isShowAddInvoice: false,
  isAddCtrl: false,
  isShowImportDialog: false
}
const reconcileBillDetailMutations = {
  mu_isShowAddInvoice(state, val) {
    state.isShowAddInvoice = val
  },
  mu_isShowDeductMoney(state, val) {
    state.isShowDeductMoney = val
  },
  mu_isAddCtrl(state, val) {
    state.isAddCtrl = val
  },
  mu_isShowImportDialog(state, val) {
    state.isShowImportDialog = val
  }
}
const reconcileBillDetailActions = {}

export { reconcileBillDetailState, reconcileBillDetailMutations, reconcileBillDetailActions }
